export default "__VITE_ASSET__6BwhIvI0__"